function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Setup → "Bring your email over" (spec: PlunkDocs/specs/SETUP_BRING_YOUR_EMAIL_OVER_2026-09-26.md).
// v1 = the Shopify Email RECREATE path: Shopify Email has no API, so the merchant picks the
// automations they run there and Plunk creates the equivalent journeys as DRAFTS (nothing sends
// until they activate one). Provider imports (Klaviyo, Mailchimp, Constant Contact, Omnisend)
// are listed but route to Connect your channels for now.

import React from "react";
import { withRouter } from "react-router";
import account from "../../data/account";
import { getOnboardingStatus } from "../../functions/onboarding-status";
import { authHeaders, apiRoot } from "../reports/common";
import { OB_CSS } from "./onboarding-css";
import { templatesFor, templateGroups } from "../email-journeys/templates";
import ServiceFactory from "../../service";
import { journeySvc } from "../email-journeys/common";
export const EMAIL_IMPORT_KEY = () => `plunk.emailImport.${(account.get() || {}).tenantId || (account.get() || {}).account || "t"}`;
const PROVIDERS = [{
  key: "shopify_email",
  name: "Shopify Email",
  how: "recreate",
  line: "Keeps sending your basics: welcome, abandoned checkout and cart, post-purchase, win-back. Nothing to import; Plunk adds what it can't run."
}, {
  key: "klaviyo",
  name: "Klaviyo",
  how: "connect",
  line: "Campaigns, templates, flows and lists (coming next)."
}, {
  key: "mailchimp",
  name: "Mailchimp",
  how: "connect",
  line: "Campaigns, templates and classic automations (coming next)."
}, {
  key: "constant_contact",
  name: "Constant Contact",
  how: "connect",
  line: "Campaigns and lists (coming next)."
}];
class EmailImportView extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "renderDesign", async design => {
      const res = await fetch(`${apiRoot()}/campaign/email/render`, {
        method: "POST",
        headers: {
          ...authHeaders(),
          "content-type": "application/json"
        },
        body: JSON.stringify({
          design,
          firstName: "Dana"
        })
      });
      const d = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(d.error || `Render failed (${res.status})`);
      return d && d.html || "";
    });
    _defineProperty(this, "createSelected", async () => {
      const {
        selected,
        b2b,
        audiences
      } = this.state;
      const picks = templatesFor({
        b2b
      }).filter(t => selected[t.key]);
      if (!picks.length) return;
      this.setState({
        working: true,
        error: null,
        created: []
      });
      const created = [];
      const audienceIdByName = {};
      (audiences || []).forEach(a => {
        audienceIdByName[String(a.name || "").toLowerCase()] = a.id;
      });
      try {
        for (const t of picks) {
          this.setState({
            progress: `Creating "${t.name}"…`
          });
          const {
            graph,
            designs
          } = t.build();
          const nodes = [];
          for (const n of graph.nodes) {
            const node = {
              ...n
            };
            if (node.type === "email" && designs[n.id]) {
              node.designJson = JSON.stringify(designs[n.id]);
              try {
                node.emailBody = await this.renderDesign(designs[n.id]);
              } catch (e) {
                node.emailBody = node.emailBody || "";
              }
            }
            nodes.push(node);
          }
          // Audience filters only when the audience exists on this workspace (the engine takes audience ids).
          const include = (t.audienceInclude || []).map(n => audienceIdByName[n.toLowerCase()]).filter(Boolean);
          const body = {
            name: t.name,
            triggerType: t.triggerType,
            triggerConfig: t.triggerConfig,
            audienceInclude: include,
            audienceExclude: [],
            senderConfig: {
              fromName: "",
              fromEmail: ""
            },
            // filled from the brand kit server-side
            graph: {
              startNodeId: graph.startNodeId,
              nodes,
              settings: {
                quietStartHourUtc: null,
                quietEndHourUtc: null,
                dailyEmailCap: null,
                templateKey: t.key
              }
            },
            // Goal: a purchase counts as reaching the goal for the recovery/win-back journeys; the
            // post-purchase ones have no goal (validator accepts conversion | eventOccurred | none).
            goal: t.goal === "conversion" ? {
              kind: "conversion",
              eventName: null
            } : {
              kind: null,
              eventName: null
            }
          };
          const r = await journeySvc().postAsync(body);
          created.push({
            id: r && r.id,
            name: t.name,
            shopifyName: t.shopifyName
          });
          if (this._alive) this.setState({
            created: [...created]
          });
        }
        try {
          localStorage.setItem(EMAIL_IMPORT_KEY(), JSON.stringify({
            state: "created",
            at: Date.now(),
            count: created.length
          }));
        } catch (e) {/* ignore */}
        try {
          await getOnboardingStatus(true);
        } catch (e) {/* ignore */}
      } catch (e) {
        if (this._alive) this.setState({
          error: e && e.message || "Something went wrong creating the journeys."
        });
      }
      if (this._alive) this.setState({
        working: false,
        progress: ""
      });
    });
    _defineProperty(this, "skip", () => {
      try {
        localStorage.setItem(EMAIL_IMPORT_KEY(), JSON.stringify({
          state: "skipped",
          at: Date.now()
        }));
      } catch (e) {/* ignore */}
      this.props.history.push("/Setup");
    });
    this.state = {
      ob: null,
      detected: {},
      b2b: false,
      selected: {},
      working: false,
      progress: "",
      created: [],
      error: null,
      audiences: []
    };
    this._alive = true;
  }
  async componentDidMount() {
    const ob = await getOnboardingStatus(false).catch(() => null);
    const detected = {
      shopify_email: !!(ob && ob.shopify)
    };
    // B2B tenants (Shopify companies → "B2B contacts" audience) get the wholesale template.
    let b2b = false,
      audiences = [];
    try {
      const AudSvc = ServiceFactory.getType("/audience", "audience");
      const d = await new AudSvc().getAsync();
      audiences = (Array.isArray(d) ? d : d && d.items || []).map(a => ({
        id: String(a.id),
        name: a.name || a.title || String(a.id)
      }));
      b2b = audiences.some(x => /^b2b contacts$/i.test(x.name || ""));
    } catch (e) {/* no audience read — templates still work */}
    // Default = only what Shopify Email cannot run; the basics stay unticked (Shopify keeps sending them).
    const selected = {};
    const groups = templateGroups({
      b2b
    });
    groups.plunkOnly.forEach(t => {
      selected[t.key] = true;
    });
    if (this._alive) this.setState({
      ob,
      detected,
      b2b,
      selected,
      audiences
    });
  }
  componentWillUnmount() {
    this._alive = false;
  }
  render() {
    const {
      detected,
      b2b,
      selected,
      working,
      progress,
      created,
      error
    } = this.state;
    const templates = templatesFor({
      b2b
    });
    const groups = templateGroups({
      b2b
    });
    const nSel = templates.filter(t => selected[t.key]).length;
    // Journey rows: name on its own line, pills beneath it (they wrapped mid-name before),
    // cells top-aligned so a two-line blurb does not float the checkbox (2026-10-01).
    const tRow = t => /*#__PURE__*/React.createElement("tr", {
      key: t.key,
      className: "ei-row",
      onClick: () => this.setState({
        selected: {
          ...selected,
          [t.key]: !selected[t.key]
        }
      })
    }, /*#__PURE__*/React.createElement("td", {
      className: "ei-check"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: !!selected[t.key],
      onChange: () => {}
    })), /*#__PURE__*/React.createElement("td", {
      className: "ei-name"
    }, /*#__PURE__*/React.createElement("b", null, t.shopifyOwns ? t.shopifyName : t.name), (t.b2b || t.shopifyOwns) && /*#__PURE__*/React.createElement("div", {
      className: "ei-pills"
    }, t.b2b && /*#__PURE__*/React.createElement("span", {
      className: "ob-pill"
    }, "B2B"), t.shopifyOwns && /*#__PURE__*/React.createElement("span", {
      className: "ob-pill warn"
    }, "Shopify Email runs this"))), /*#__PURE__*/React.createElement("td", {
      className: "ei-what"
    }, t.shopifyOwns && /*#__PURE__*/React.createElement("div", {
      className: "ei-plunk"
    }, t.name), /*#__PURE__*/React.createElement("div", {
      className: "ei-blurb"
    }, t.blurb)), /*#__PURE__*/React.createElement("td", {
      className: "ei-steps"
    }, t.steps));
    return /*#__PURE__*/React.createElement("div", {
      className: "ob-root"
    }, /*#__PURE__*/React.createElement("style", null, OB_CSS), /*#__PURE__*/React.createElement("div", {
      className: "ob-shell"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ob-main"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ob-eyebrow"
    }, /*#__PURE__*/React.createElement("a", {
      style: {
        cursor: "pointer"
      },
      onClick: () => this.props.history.push("/Setup")
    }, "\u2190 Setup")), /*#__PURE__*/React.createElement("div", {
      className: "ob-hrow"
    }, /*#__PURE__*/React.createElement("h2", null, "Add what Shopify Email can't")), /*#__PURE__*/React.createElement("div", {
      className: "ob-next"
    }, "Shopify Email keeps sending your basics: welcome, abandoned checkout and cart, post-purchase, win-back. Plunk adds the journeys Shopify cannot run: wholesale and dealer reorders, browse follow-ups with recommendations, and journeys on your Plunk data. ", /*#__PURE__*/React.createElement("b", null, "Nothing sends until you review and activate it.")), /*#__PURE__*/React.createElement("div", {
      className: "ob-band"
    }, "Where does your email live today?"), PROVIDERS.filter(p => p.how !== "connect").map(p => /*#__PURE__*/React.createElement("div", {
      key: p.key,
      className: `ob-card${p.how === "recreate" ? " hot" : ""}`
    }, /*#__PURE__*/React.createElement("div", {
      className: `ob-st${p.how === "recreate" ? " now" : ""}`
    }, p.how === "recreate" ? "✉" : "→"), /*#__PURE__*/React.createElement("div", {
      className: "ob-t"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ob-h"
    }, /*#__PURE__*/React.createElement("b", null, p.name), detected[p.key] && /*#__PURE__*/React.createElement("span", {
      className: "ob-pill ok"
    }, "Detected"), p.how === "connect" && /*#__PURE__*/React.createElement("span", {
      className: "ob-pill"
    }, "Coming next")), /*#__PURE__*/React.createElement("p", null, p.line)), /*#__PURE__*/React.createElement("div", {
      className: "ob-act"
    }, p.how === "connect" && /*#__PURE__*/React.createElement("button", {
      className: "ob-btn ghost sm",
      onClick: () => this.props.history.push("/Data/Connect")
    }, "Connect your channels")))), /*#__PURE__*/React.createElement("div", {
      className: "ob-band mk"
    }, "Journeys only Plunk can run"), !created.length ? /*#__PURE__*/React.createElement("div", {
      className: "ob-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ob-t",
      style: {
        width: "100%"
      }
    }, groups.plunkOnly.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
      style: {
        marginTop: 0
      }
    }, "These use data Shopify Email never sees: your wholesale accounts, reps and Plunk's behavior and lifecycle rails. Each one is created as a ", /*#__PURE__*/React.createElement("b", null, "draft journey"), " in your brand."), /*#__PURE__*/React.createElement("table", {
      className: "ei-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      className: "ei-check"
    }), /*#__PURE__*/React.createElement("th", null, "Journey"), /*#__PURE__*/React.createElement("th", null, "What it does"), /*#__PURE__*/React.createElement("th", {
      className: "ei-steps"
    }, "Steps"))), /*#__PURE__*/React.createElement("tbody", null, groups.plunkOnly.map(tRow)))) : /*#__PURE__*/React.createElement("p", {
      style: {
        marginTop: 0
      }
    }, "Nothing to set up yet: Shopify Email already covers your retail basics, and your store has no wholesale accounts. Plunk journeys become useful here once you sell to dealers or want journeys on lifecycle and behavior data. You can build one any time under Journeys."), /*#__PURE__*/React.createElement("div", {
      className: "ob-band",
      style: {
        marginTop: 14
      }
    }, "Already running in Shopify Email"), /*#__PURE__*/React.createElement("p", {
      className: "territory-hint"
    }, "Shopify Email sends these today. Recreate one here ", /*#__PURE__*/React.createElement("b", null, "only"), " if you are turning it off in Shopify Email, otherwise customers get both. Activating one of these asks you to confirm the Shopify one is paused."), /*#__PURE__*/React.createElement("table", {
      className: "ei-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      className: "ei-check"
    }), /*#__PURE__*/React.createElement("th", null, "In Shopify Email"), /*#__PURE__*/React.createElement("th", null, "In Plunk"), /*#__PURE__*/React.createElement("th", {
      className: "ei-steps"
    }, "Steps"))), /*#__PURE__*/React.createElement("tbody", null, groups.shopifyOwns.map(tRow))), error && /*#__PURE__*/React.createElement("p", {
      style: {
        color: "#b3261e"
      }
    }, error), /*#__PURE__*/React.createElement("div", {
      className: "ob-act",
      style: {
        marginLeft: 0,
        marginTop: 12,
        flexDirection: "row",
        flexWrap: "wrap",
        gap: 8
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "ob-btn",
      disabled: working || !nSel,
      onClick: this.createSelected
    }, working ? progress || "Creating…" : `Create ${nSel} draft journey${nSel === 1 ? "" : "s"}`), /*#__PURE__*/React.createElement("button", {
      className: "ob-btn ghost sm",
      disabled: working,
      onClick: this.skip
    }, "Skip for now")))) : /*#__PURE__*/React.createElement("div", {
      className: "ob-card done"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ob-st done"
    }, "\u2713"), /*#__PURE__*/React.createElement("div", {
      className: "ob-t"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ob-h"
    }, /*#__PURE__*/React.createElement("b", null, created.length, " journey", created.length === 1 ? "" : "s", " ready as drafts"), /*#__PURE__*/React.createElement("span", {
      className: "ob-pill ok"
    }, "Done")), /*#__PURE__*/React.createElement("ul", {
      style: {
        margin: "6px 0 10px 18px",
        padding: 0
      }
    }, created.map(c => /*#__PURE__*/React.createElement("li", {
      key: c.id || c.name
    }, c.name, " ", /*#__PURE__*/React.createElement("span", {
      className: "territory-hint"
    }, "(Shopify Email: ", c.shopifyName, ")"), c.id && /*#__PURE__*/React.createElement(React.Fragment, null, " \xB7 ", /*#__PURE__*/React.createElement("a", {
      style: {
        cursor: "pointer"
      },
      onClick: () => this.props.history.push(`/Email/journeys/detail/${c.id}`)
    }, "open"))))), /*#__PURE__*/React.createElement("p", null, "Open a journey, check the sender and copy, and activate it. Journeys marked \"Shopify Email runs this\" ask you to confirm the Shopify automation is paused before they go live.")), /*#__PURE__*/React.createElement("div", {
      className: "ob-act"
    }, /*#__PURE__*/React.createElement("button", {
      className: "ob-btn",
      onClick: () => this.props.history.push("/Email/journeys")
    }, "Review journeys"), /*#__PURE__*/React.createElement("button", {
      className: "ob-btn ghost sm",
      onClick: () => this.props.history.push("/Setup")
    }, "Back to Setup"))))));
  }
}
export const EmailImportViewComponent = withRouter(EmailImportView);
export default EmailImportViewComponent;